include ../../../../../common/primary/icon/icon.mixin.pug

component.fp-member-card(:class='{"-clickable": !member.me}' :is='member.me ? "div" : "router-link"' :to='{name: \'chatPage\', params: { memberId: member.id }}')
  .fp-image.-circled.-xl
    FanImageVue(:url='member.pictureUrl', data-test='picture')
  span.fp-text.-text-semi-bold.-text-md.-lines-2.-color-shade-700(data-test='name') {{ member.firstName }} {{ member.lastName }}
  a.fp-link.-secondary(v-if='!member.me' data-test='contact') {{ t('members.contact') }}
  span.fp-text.-secondary.-color-shade-500(v-else data-test='you') {{ t('members.you') }}
